var App = App || {};

App.Compare = (function ($) {
    'use strict';

    var Bps = ["xs", "sm", "md"],
        Bpm =["md"],
        Bp = ZAGFramework.GetCurrentBP(),
        ColumnsAllowed = 2;

    function init() {
        CompareSetup()
        $(document).bind("enter-xs enter-sm enter-md enter-lg enter-xl enter-xxl", function () { CompareSetup() });        
    }

    function CompareSetup() {
        Bp = ZAGFramework.GetCurrentBP();

        $(".component-compare-chart").each(function () {

            var Component = $(this),
                Controls = Component.find(".component-compare-chart-controls").find(".form-check-input");

            ColumnsAllowed = $(Controls).length;

            if (Bps.includes(Bp)) {
                if (Bpm.includes(Bp)) {
                    if ($(Controls).length >= 3) { //allow up to 3 column comparison on tablet
                        ColumnsAllowed = 3;
                    }
                }
                else if ($(Controls).length >= 2) { //allow up to 2 column comparison on mobile
                    ColumnsAllowed = 2;
                }
            } else if ($(Controls).length >= 4) { //allow up to 4 columns above mobile
                ColumnsAllowed = 4;
            }

            Controls.prop("checked", false).attr("disabled", "disabled");
            for (var i = 0; i < ColumnsAllowed; i++) {
                $(Controls[i]).prop("checked", true).removeAttr("disabled");
            }

            CompareUpdate(Component);
            Controls.on("change", function () { CompareUpdate(Component); });

        });
    }

    function CompareUpdate(Component) {
        var Controls = Component.find(".component-compare-chart-controls"),
            ChartContent = Component.find(".component-compare-chart-content"),
            ControlsChecked = [];

        Controls.find(".form-check-input").each(function () {
            if ($(this).prop("checked")) {
                ControlsChecked.push($(this).attr("id"));
            }
        });

        //if allowed number of options are selected, disable the rest
        if (ControlsChecked.length >= ColumnsAllowed) {
            Controls.find(".form-check-input").each(function () {
                if (!$(this).prop("checked")) {
                    $(this).attr("disabled", "disabled");
                }
            });
        }
        else { //otherwise enable all
            Controls.find(".form-check-input").each(function () {
                $(this).removeAttr("disabled");
            });
        }

        //only show controls if chart is capable of exceding bounds
        if ($(Controls).find(".form-check-input").length > ColumnsAllowed) {
            Controls.removeClass("hide");
        } else {
            Controls.addClass("hide");
        }

        if (!ControlsChecked.length) { ChartContent.hide(); }
        else { ChartContent.show(); }

        var lastVisibleColumn = ControlsChecked[ControlsChecked.length - 1],
            firstVisibleColumn = ControlsChecked[0];
        Component.find("[data-controlledby]").each(function () {
            var Control = $(this).attr("data-controlledby");
            if (ControlsChecked.includes(Control)) {
                $(this).show();
            } else {
                $(this).hide();
            }

            //apply first & last column styling, e.g. rounded borders
            if (Control == lastVisibleColumn) {
                $(this).addClass("last-visible-column");
            }
            else {
                $(this).removeClass("last-visible-column");
            }
            if (Control == firstVisibleColumn) {
                $(this).addClass("first-visible-column");
            }
            else {
                $(this).removeClass("first-visible-column");
            }
        });

    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    App.Compare.init();
});